import { render } from "./Button_M1.vue?vue&type=template&id=1a20955d"
import script from "./Button_M1.vue?vue&type=script&lang=js"
export * from "./Button_M1.vue?vue&type=script&lang=js"

import "./Button_M1.vue?vue&type=style&index=0&id=1a20955d&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__